import React from 'react';
export function Footer() {
  return <footer className="bg-ink px-6 py-10 text-center text-xs leading-relaxed text-muted/60" data-id="element-55" data-mp="32wmqrybuniwl">
      <p data-id="element-56" data-mp="3ggtwodvnbb34">© 2026 MSc Beatriz Espina · ELEGIDA. Todos los derechos reservados.</p>
      <p className="mt-2" data-id="element-57" data-mp="32ovvcp86ejhi">
        Pago procesado de forma segura por Hotmart. Los resultados pueden variar de una persona a otra.
      </p>
    </footer>;
}